import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '100%',
      borderRadius: '16px',
      textAlign: 'center',
      paddingBottom: '1rem'
    },
    header: {
      marginBottom: '1.5rem !important',
      marginTop: '.5rem !important'
    },
    text: {
      padding: '0',
      fontFamily: 'OutfitHeavy',
      textTransform: 'uppercase',
      textAlign: 'left',
      marginBottom: '2rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
        textAlign: 'center',
        marginBottom: '.5rem'
      }
    },
    boxes: {
      display: 'flex',
      // gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '1rem',
      padding: '0',
      paddingBottom: '1rem',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
      }
    },
    box: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '280px',
      textAlign: 'left',
      border: '2px solid #F5F6F7',
      borderRadius: 8,
      boxShadow: '0px 3px 5px rgba(26, 42, 85, 0.2), 0px 0px 1px rgba(26, 42, 85, 0.31)',
      padding: '8px',
      position: 'relative',
      cursor: 'pointer',
      '&:hover': {
        border: '2px solid var(--bosscat-blue-600)',
        transition: '300ms all',
        '@global': {
          '.MuiSvgIcon-root': {
            fill: 'var(--bosscat-blue-600)',
          }
        }
      },
      '@global': {
        'img': {
          [theme.breakpoints.down('sm')]: {
            gridArea: 'img',
            width: 55,
            marginRight: '.5rem'
          }
        }
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'grid',
        gridTemplateAreas: ' "img title button" "img subtitle button"'
      }
    },
    noAbsolute: {
      position: 'relative'
    },
    radioButton: {
      position: 'absolute',
      right: '8px',
      padding: 0,
      width: 'fit-content',
      height: 'fit-content',
      minWidth: 'fit-content',
      '@global': {
        '.MuiButton-label': {
          width: 'fit-content'
        }
      },
      [theme.breakpoints.down('sm')]: {
        gridArea: 'button'
      }
    },
    title: {
      color: '#0B060F',
      fontSize: 18,
      marginBottom: '.5rem',
      [theme.breakpoints.down('sm')]: {
        gridArea: 'title',
        marginBottom: '0'
      }
    },
    subtitle: {
      color: '#6D6A6F',
      [theme.breakpoints.down('sm')]: {
        gridArea: 'subtitle'
      }
    },
    closeButton: {
      padding: 0,
      minWidth: '32px',
      height: '32px',
      '@global': {
        '.MuiSvgIcon-root': {
          width: '0.7em',
        }
      }
    }
  })
)
